
export default class Satisfaction{

  constructor(){
    this.document = null;
    this.question1 = null;
    this.question2 = null;
    this.question3 = null;
    this.question4 = null;
    this.question5 = null;
    this.question6 = null;
    this.question7 = null;
    this.question8 = null;
  }

  reset(){
    this.document = null;
    this.question1 = null;
    this.question2 = null;
    this.question3 = null;
    this.question4 = null;
    this.question5 = null;
    this.question6 = null;
    this.question7 = null;
    this.question8 = null;
  }

}